import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Helmet } from 'react-helmet-async'

import CustomPaper from '@/components/custom-paper'
import CollectionPointCategoriesTabs from '@/components/collection-point-categories/tabs'
import MunicipalityPermissionGate from '@/components/municipality-permission-gate'

function CollectionPointCategoriesView() {

    const title = 'Seznam svozových míst a jejich kategorií'

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <CustomPaper noPadding>
                <Box p={2.5}>
                    <Typography variant="h2" component="h1">
                        {title}
                    </Typography>
                </Box>
                <MunicipalityPermissionGate>
                    <CollectionPointCategoriesTabs />
                </MunicipalityPermissionGate>
            </CustomPaper>
        </>
    )
}

export default CollectionPointCategoriesView
